module.exports = __webpack_public_path__ + "media/Video 85.f4c06686.mp4";